import {
  afterNextRender,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  HostListener,
  inject,
  Inject,
  OnInit,
  Optional,
  Output,
} from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import SignaturePad from 'signature_pad';

import { AdminService } from '../../admin/services/admin.service';
import { CameraService } from '../image-uploader/camera/camera.service';
import { FirebaseService } from './../../services/firebase.service';
import { getDownloadURL } from 'firebase/storage';

@Component({
    selector: 'app-sign',
    templateUrl: './sign.component.html',
    styleUrls: ['./sign.component.scss'],
    standalone: false
})
export class SignComponent implements OnInit {
  signaturePad:SignaturePad;

  uploading = false;

  progress = 0;

  company:any;

  termMode = true;
  
  firebase = inject(FirebaseService);

  @Output() saved = new EventEmitter();

  constructor(
    private adminService: AdminService,
    private dialogRef: MatDialogRef<SignComponent>,
    private cdr: ChangeDetectorRef,
    @Optional() @Inject(MAT_DIALOG_DATA) public data: any,
  ) {
    afterNextRender(() => {
      this.setupSign();
    });
  }

  ngOnInit() {
    this.company = this.adminService.local$.getValue();
  }

  setupSign() {
    this.cdr.markForCheck();
    const canvas = document.querySelector('canvas');
    canvas.width = window.innerWidth;
    canvas.height = window.innerHeight - 66;
    const ctx = canvas.getContext('2d', { willReadFrequently: true });
    if (!ctx) {
      throw new Error('No se pudo obtener el contexto 2D');
    }
    this.signaturePad = new SignaturePad(canvas, {
      minWidth: 2,
    });
    this.signaturePad.addEventListener('beginStroke', () => {
      this.cdr.markForCheck();
    });
  }
  

  close() {
    if (this.dialogRef instanceof MatDialogRef) {
      this.dialogRef.close();
    } else {
      this.saved.emit(false);
    }
  }

  clearSign() {
    this.signaturePad.clear();
  }

  @HostListener('window:resize', ['$event'])
  onResize() {
    this.setupSign();
  }

  saveSign() {
    const imageData = this.trimImage(document.querySelector('canvas')).toDataURL().substr(22);
    this.uploading = true;
    const filePath = `signs/${new Date().toISOString()}-${Math.random() * 100000}.png`;
    
    this.firebase.uploadString(imageData, filePath, 'base64', { contentType: 'image/png' }).then((uploadResult) => {
      getDownloadURL(uploadResult.ref).then((downloadURL) => {
        this.uploading = false;
        if (this.dialogRef instanceof MatDialogRef) {
          this.dialogRef.close(downloadURL);
        } else {
          this.saved.emit(downloadURL);
        }
      });
    });
  }

  trimImage(c: any) {
    const ctx = c.getContext('2d', { willReadFrequently: true });
    const copy = document.createElement('canvas').getContext('2d', { willReadFrequently: true });
    const pixels = ctx.getImageData(0, 0, c.width, c.height);
    const l = pixels.data.length;
    const bound = {
      top: null,
      left: null,
      right: null,
      bottom: null,
    };
    let i; let x; let
      y;

    for (i = 0; i < l; i += 4) {
      if (pixels.data[i + 3] !== 0) {
        x = (i / 4) % c.width;
        y = ~~((i / 4) / c.width);

        if (bound.top === null) {
          bound.top = y;
        }

        if (bound.left === null) {
          bound.left = x;
        } else if (x < bound.left) {
          bound.left = x;
        }

        if (bound.right === null) {
          bound.right = x;
        } else if (bound.right < x) {
          bound.right = x;
        }

        if (bound.bottom === null) {
          bound.bottom = y;
        } else if (bound.bottom < y) {
          bound.bottom = y;
        }
      }
    }

    const trimHeight = bound.bottom - bound.top;
    const trimWidth = bound.right - bound.left;
    const trimmed = ctx.getImageData(bound.left, bound.top, trimWidth, trimHeight);

    copy.canvas.width = trimWidth;
    copy.canvas.height = trimHeight;
    copy.putImageData(trimmed, 0, 0);

    // open new window with trimmed image:
    return copy.canvas;
  }
}
